import React, { useState } from 'react';
import { View, Pressable, Text } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons';

import { FieldLabel, StyledTextInput } from 'app/src/elements/inputs';
import Modal from 'app/src/elements/Modal';
import { Button, ButtonGroup } from 'app/src/elements/buttons';

import { currency } from './index';

export const Counter = props => {
  const { saleAsset, setShowModal, updateOffer, setShowSaleHistory } = props;

  const [counterPrice, setCounterPrice] = useState('');
  const [counterNote, setCounterNote] = useState('');

  const saveCounter = () => {
    updateOffer({ counterPrice, counterNote });
  };

  return (
    <Modal
      showModal
      setShowModal={setShowModal}
      modalType={saleAsset.correctedLotNumber}
      objectName={saleAsset.asset.name}
    >
      <View style={{flexDirection: 'row', gap: 10, marginBottom: 10}}>
        <Text>
          Latest Bid: {currency(saleAsset.activeOffer.price)}
        </Text>
        <Pressable
          onPress={() => setShowSaleHistory(saleAsset)}
          style={{display: 'inline-block'}}
        >
          <FontAwesomeIcon
            icon={faClockRotateLeft}
            title="View Bid History"
          />
        </Pressable>
      </View>
      <FieldLabel label="Counter Offer" />
      <StyledTextInput
        onChange={e => setCounterPrice(e.target.value)}
        value={counterPrice || ''}
      />
      <br />
      <FieldLabel label="Note (optional)" />
      <StyledTextInput
        onChange={e => setCounterNote(e.target.value)}
        value={counterNote || ''}
      />
      <ButtonGroup>
        <Button label="Update" onPress={saveCounter} />
      </ButtonGroup>
    </Modal>
  );
};

export default Counter;
